import { render, staticRenderFns } from "./Baggage.vue?vue&type=template&id=1960652a&scoped=true"
import script from "./Baggage.vue?vue&type=script&lang=js"
export * from "./Baggage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960652a",
  null
  
)

export default component.exports